package ai.wagemix.net.models

import com.fsryan.foundation.models.toEnumValue
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

interface WMFileUploadUpdate {
    val message: String
    val inProgress: Boolean
    val successful: Boolean
    /** On the final, unsuccessful update: why the upload produced no mix, when the pipeline knows. */
    val reason: WMUploadFailureReason?
    companion object
}

fun WMFileUploadUpdate.Companion.kxs(
    message: String,
    inProgress: Boolean,
    successful: Boolean,
    reason: WMUploadFailureReason?
): KxsWMFileUploadUpdate {
    return KxsWMFileUploadUpdate(
        message = message,
        inProgress = inProgress,
        successful = successful,
        reasonValue = reason?.stringValue
    )
}

fun WMFileUploadUpdate.Companion.inProgressKxs(message: String, successful: Boolean = true): KxsWMFileUploadUpdate {
    return WMFileUploadUpdate.kxs(message = message, inProgress = true, successful = successful, reason = null)
}
fun WMFileUploadUpdate.Companion.completedMixRefKxs(mixRefId: String): KxsWMFileUploadUpdate {
    return WMFileUploadUpdate.kxs(message = mixRefId, inProgress = false, successful = true, reason = null)
}
fun WMFileUploadUpdate.Companion.errorKxs(
    message: String,
    reason: WMUploadFailureReason? = null
): KxsWMFileUploadUpdate {
    return WMFileUploadUpdate.kxs(message = message, successful = false, inProgress = false, reason = reason)
}

fun WMFileUploadUpdate.toKxs(): KxsWMFileUploadUpdate = when (this) {
    is KxsWMFileUploadUpdate -> this
    else -> WMFileUploadUpdate.kxs(message = message, inProgress = inProgress, successful = successful, reason = reason)
}

@ConsistentCopyVisibility
@Serializable
data class KxsWMFileUploadUpdate internal constructor(
    override val message: String,
    override val inProgress: Boolean,
    override val successful: Boolean,
    /** Absent from updates sent before the reason was recorded. */
    @SerialName("reason") val reasonValue: String? = null
): WMFileUploadUpdate {
    override val reason: WMUploadFailureReason? get() = reasonValue?.toEnumValue(WMUploadFailureReason.Unknown)
}